let poly = require("preact-cli/lib/lib/webpack/polyfills");

if ( module.hot ) {
  require( 'preact/debug' );
  require( 'preact/devtools' );
} else {
  require( 'preact/devtools' );
}

import React from 'react';
import habitat from "preact-habitat";

import Widget from "./components/scores";

let _habitat = habitat(Widget);

_habitat.render({
  selector: '[data-widget-id="sports-scores"]',
  defaultProps: {
    title: '',
    groupBy: 'league_short',
    noScores: 'There are currently no scores to display. Please come back soon.',
  },
  clean: true
});
